<template>
    <div id="UserVoucher">
        <el-card>
            <div class="AdminTopOper">
                <el-space wrap :size="15">
                    <el-input v-model="pageData.searchKey" placeholder="请输入订单号"></el-input>
                    <el-input style="width: 120px" v-model="pageData.where.id" placeholder="请输入ID"></el-input>
                    <el-button type="primary" icon="Search" @click="orderSearce()">搜索</el-button>
                    <el-button type="primary" icon='Plus' @click="pageData.handleCreate()">新建</el-button>


                </el-space>
            </div>
            <!-- 表格主体 -->
            <el-table :data="pageData.rows">
                <el-table-column prop="id" label="编号" width="100" />
                <el-table-column label="优惠名称" width="150">
                    <template #default="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="userId" width="180">
                    <template #default="scope">
                        {{ scope.row.userId }}
                    </template>
                </el-table-column>
                <el-table-column label="VoucherTemplateId" width="200">
                    <template #default="scope">
                        {{ scope.row.VoucherTemplateId }}
                    </template>
                </el-table-column>

                <el-table-column label="status" width="100">
                    <template #default="scope">

                        {{ scope.row.status }}
                    </template>
                </el-table-column>
                <el-table-column label="validFrom" width="100">
                    <template #default="scope">
                        {{ scope.row.validFrom }}
                    </template>
                </el-table-column>
                <el-table-column label="validTo" width="100">
                    <template #default="scope">
                        {{ scope.row.validTo }}
                    </template>
                </el-table-column>
                <el-table-column label="useTime" width="100">
                    <template #default="scope">
                        {{ scope.row.useTime }}
                    </template>
                </el-table-column>
                <AdminTableButton :showEdit="true" width="200" fixed="right"> </AdminTableButton>
            </el-table>

            <AdminPagination :showEdit="false"> </AdminPagination>
        </el-card>


        <!-- 新建与编辑dialog -->
        <el-dialog v-model="pageData.dialogVisible" title="新建" width="800px">
            <el-form ref="form" :model="pageData.row" label-width="100px" size='medium'>
                <el-form-item label="userId">
                    <el-input v-model="pageData.row.userId"></el-input>
                </el-form-item>
                <el-form-item label="VoucherTemplateId">
                    <el-input v-model="pageData.row.VoucherTemplateId"></el-input>
                </el-form-item>
                <el-form-item label="useTime">
                    <el-input v-model="pageData.row.useTime"></el-input>
                </el-form-item>

                <!-- <el-form-item label="status">
                    <el-input v-model="pageData.row.status"></el-input>
                </el-form-item>
                <el-form-item label="validFrom">
                    <el-input v-model="pageData.row.validFrom"></el-input>
                </el-form-item>
                <el-form-item label="validTo">
                    <el-input v-model="pageData.row.validTo"></el-input>
                </el-form-item>
 -->


            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="pageData.dialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="pageData.create()">Confirm</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { onMounted, onUpdated, reactive, ref, watch } from 'vue'
import Api from '@/network'
const pageData = reactive(Api.adminPage('UserVoucher'))
pageData.where.count = null
onMounted(pageData.getPage())


</script>



<style lang="less"></style>